<div class="dynamic-field form-input col-12" [formGroup]="group">
    <div class="row" style="margin-bottom: 5px;">
      <div class="col-3">
        <label>{{ config.description }} <span *ngIf="config.validation" style="color: red"> *</span></label>
      </div>
      <div class="col-9">
          <textarea pInputTextarea class="form-control" [formControlName]="config.description"></textarea>
      </div>
    </div>
  </div>